export default __webpack_public_path__ + "static/media/spooky_hill_l3.1971d3bb.png";